// Theme preference: applied immediately from local preference (no flash), and synced to the
// user's profile (profiles.theme) so it follows them across devices.
import { getPref, setPref } from '../utilities/storage.js';

export const THEMES = ['dark', 'light', 'system'];

export function currentTheme() {
  const t = getPref('theme', 'dark');
  return THEMES.includes(t) ? t : 'dark';
}

export function applyTheme(theme) {
  const t = THEMES.includes(theme) ? theme : 'dark';
  document.documentElement.setAttribute('data-theme', t);
  setPref('theme', t);
  document.dispatchEvent(new CustomEvent('ngw:theme', { detail: t }));
  return t;
}

/** Effective (resolved) theme, accounting for "system". */
export function resolvedTheme(theme = currentTheme()) {
  if (theme !== 'system') return theme;
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function nextTheme(theme = currentTheme()) {
  return THEMES[(THEMES.indexOf(theme) + 1) % THEMES.length];
}
